export default __webpack_public_path__ + "static/media/freedom-blue.f4be36a5.png";